import {lazy} from 'react';
import Wrapper from '@common/pages/Wrapper';
import TabsComponent from '@common/TabsComponent';
import AppSettingsTab from '@/components/pages/settings/AppSettingsTab';
import EventConsumersTab from '@/components/pages/settings/event_consumers/EventConsumersTab';
import FormFields from "@/components/pages/settings/form_fields/FormFields";
import DropdownItems from "@/components/pages/settings/dropdown_items/DropdownItems";
import TelephonySettings from "@/components/pages/settings/telephony/TelephonySettings";

const FormTemplatesTab = lazy(() => import('@/components/pages/settings/form_templates/FormTemplatesTab'));
const WorkflowsTab = lazy(() => import('@/components/pages/settings/workflows/WorkflowsTab'));
const WorkflowRoutingTab = lazy(() => import('@/components/pages/settings/workflow_routing/WorkflowRoutingTab'));

export default function SettingsPage() {
  return (
    <Wrapper>
      <TabsComponent
        tabs={[
          {
            value: 0,
            label: 'App Settings',
            route: '/settings/app_settings',
            content: <AppSettingsTab />,
          },
          {
            value: 1,
            label: 'Form Templates',
            route: '/settings/form_templates',
            content: () => <FormTemplatesTab />,
          },
          {
            value: 2,
            label: 'Workflows',
            route: '/settings/workflows',
            content: () => <WorkflowsTab />,
          },
          {
            value: 3,
            label: 'Workflow Routing',
            route: '/settings/workflow_routing',
            content: () => <WorkflowRoutingTab />,
          },
          {
            value:4,
            label: 'Forms Fields',
            route: '/settings/form_fields',
            content: <FormFields />
          },
          {
            value: 5,
            label: 'Event Consumers',
            route: '/settings/event_consumers',
            content: <EventConsumersTab />,
          },
          {
            value: 6,
            label: 'Dropdown Items',
            route: '/settings/dropdown_items',
            content: <DropdownItems />,
          },
          {
            value: 7,
            label: 'Telephony',
            route: '/settings/telephony',
            content: <TelephonySettings />,
          },
        ]}
      />
    </Wrapper>
  );
}
